import React, { useEffect, useState } from "react";
import Map from "../components/Map";
import FormContainer from "../components/FormContainer";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Form, Button, Tabs, Tab } from "react-bootstrap";
import specialityList from "../data/specialty";
import MemberForm from "../components/MemberForm";
import Member from "../components/Member";
import { useDispatch, useSelector } from "react-redux";
import {
  getClinicDetails,
  updateClinicDetails,
} from "../actions/clinicActions";
import Skeleton from "react-loading-skeleton";
import Loader from "../components/Loader";
import Message from "../components/Message";
import {
  CLINIC_DETAILS_RESET,
  CLINIC_UPDATE_RESET,
} from "../constants/clinicConstants";
import { notify } from "../components/notify";
import { Howl } from "howler";
import TextEditor from "../components/TextEditor";
import Help from "../components/Help";
import { FaHome, FaSave } from "react-icons/fa";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import ClinicDefaultPatientNote from "../components/ClinicDefaultPatientNote";
import ClinicServices from "../components/ClinicServices";
import ClinicFollowups from "../components/ClinicFollowups";
import ClinicDefaultPhysicianNote from "../components/ClinicDefaultPhysicianNote";
import ClinicChecklists from "../components/ClinicChecklists";
import ClinicPatientTags from "../components/ClinicPatientTags";
import MyLines from "../components/MyLines";

const ClinicEditScreen = () => {
  const params = useParams();
  const clinicId = params.clinicId;

  const [selected, setSelected] = useState([]);
  const [clinicName, setClinicName] = useState("");
  const [specialtyId, setSpecialtyId] = useState("");
  const [chatGPT_Ask, setChatGPT_Ask] = useState("");
  const [members, setMembers] = useState([]);
  const [defaultPatientNote, setDefaultPatientNote] = useState("");
  const [clinicServices, setClinicServices] = useState([]);
  const [clinicFollowups, setClinicFollowups] = useState([]);
  const [clinicCheckLists, setClinicChecklists] = useState([]);
  const [defaultPhysicianNote, setDefaultPhysicianNote] = useState("");
  const [patientTags, setPatientTags] = useState([]);

  const [message, setMessage] = useState();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const clinicDetails = useSelector((state) => state.clinicDetails);
  const { noRequest, loading, clinic, error } = clinicDetails;

  const clinicUpdateStore = useSelector((state) => state.clinicUpdateStore);
  const {
    noRequest: noReqLoad,
    loading: updatingLoad,
    updatedClinic,
    error: clinicUpdateErr,
  } = clinicUpdateStore;

  const isAdmin =
    clinic?.members.find((m) => m.memberId?.toString() === userInfo?._id)
      ?.permissionId === "0";

  const dispatch = useDispatch();
  const submitHandler = () => {
    if (noReqLoad) {
      dispatch(
        updateClinicDetails({
          _id: clinicId,
          clinicName,
          specialtyId,
          chatGPT_Ask,
          members: members.map((m) => {
            return {
              memberId: m.memberId,
              permissionId: m.permissionId,
            };
          }),
        }),
      );
    }
  };

  const editWarn = () => {
    notify({
      title: "Edit Warning",
      message: (
        <p className="lead">
          Changes need to be saved.
          <br /> Click on Save 👇👇
        </p>
      ),
      type: "info",
      duration: 3000,
    });
  };

  const deleteMember = (d) => {
    if (window.confirm("You will delete this member. Are you sure?")) {
      setMembers(members.filter((m) => m.memberId !== d.memberId));
      editWarn();
    }
  };

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!userInfo) {
      navigate(`/login-screen?returnFrom=${location.pathname}`);
    } else {
      if (!clinic || clinic._id !== clinicId) {
        if (noRequest) {
          dispatch(getClinicDetails(clinicId));
        }
      } else {
        if (!isAdmin) {
          notify({
            title: "Permission Error",
            message: (
              <p className="lead">You have NO permission to such data.</p>
            ),
            type: "danger",
            duration: 3000,
          });
          navigate("/clinic-list-screen");
        }

        setClinicName(clinic.clinicName);
        setSpecialtyId(clinic.specialtyId);
        setMembers(clinic.members);
        setChatGPT_Ask(clinic.chatGPT_Ask);
        setDefaultPatientNote(clinic.defaultPatientNote || "");
        setDefaultPhysicianNote(clinic.defaultPhysicianNote || "");
        setClinicServices(
          clinic.clinicServices.length > 0
            ? clinic.clinicServices
            : [{ idx: Math.random(), label: "", price: "0", isHide: false }],
        );
        setClinicChecklists(
          clinic.clinicCheckLists || [
            {
              idx: Math.random(),
              title: "",
              edit: true,
              subtitles: [],
            },
          ],
        );
        setClinicFollowups(
          clinic.clinicFollowups.length > 0
            ? clinic.clinicFollowups
            : [
                {
                  idx: Math.random,
                  label: "",
                  upperLimit: "0",
                  lowerLimit: "10",
                  isHide: false,
                },
              ],
        );
        setPatientTags(
          clinic.patientTags?.length > 0
            ? clinic.patientTags
            : [
                {
                  idx: Math.random(),
                  label: "",
                  isHide: false,
                },
              ],
        );
      }
    }
    if (updatedClinic) {
      notify({
        title: "Update Success",
        message: <p className="lead">Changes updated successfully 👏👏.</p>,
        type: "success",
        duration: 3000,
      });
      var sound = new Howl({
        src: `/success.mp3`,
      });
      sound.play();
      dispatch({ type: CLINIC_UPDATE_RESET });
      dispatch({ type: CLINIC_DETAILS_RESET });
    }
    if (clinicUpdateErr) {
      setMessage(clinicUpdateErr);
    }
  }, [userInfo, noRequest, clinicId, clinic, updatedClinic, clinicUpdateErr]);

  useEffect(() => {
    if (selected.length > 0) {
      const selectedOption = selected[0];
      setSpecialtyId(selectedOption._id);
    }
  }, [selected]);
  return (
    <FormContainer>
      {!clinic ? (
        <Skeleton height="50px" className="mb-5" />
      ) : (
        <Map
          titles={[
            {
              idx: "1",
              label: (
                <>
                  <FaHome /> Home
                </>
              ),
              path: `/`,
              active: false,
            },
            {
              idx: "2",
              label: `Clinic List Screen`,
              path: `/clinic-list-screen`,
              active: false,
            },
            {
              idx: "3",
              label: `${clinic.clinicName}`,
              path: `/clinic-screen/${clinic._id}`,
              active: false,
            },
            {
              idx: "4",
              label: `Edit`,
              path: ``,
              active: true,
            },
          ]}
        />
      )}
      {updatingLoad ||
        (loading && (
          <>
            <Loader />
          </>
        ))}

      {error && (
        <>
          <Message
            children={`Get Clinic Details Err:${error}`}
            variant={`danger`}
          />
        </>
      )}
      {message && (
        <>
          <Message
            children={`Clinic Update Err:${message}`}
            variant={`danger`}
          />
        </>
      )}

      {clinic && (
        <Form className="mx-4 my-2">
          <Form.Label>
            <h3>Manage Clinic Profile</h3>
          </Form.Label>
          <Form.Group controlId="clinicName">
            <Form.Label>Clinic Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Clinic Name"
              value={clinicName}
              onChange={(e) => setClinicName(e.target.value)}
              isValid={clinicName}
            ></Form.Control>
          </Form.Group>
          <Form.Group controlId="specialtyId">
            <Form.Label>Specialty</Form.Label>
            <Typeahead
              placeholder="Select your specialty"
              options={specialityList}
              onChange={(e) => setSelected(e)}
              selected={specialityList.filter(
                (s) => s._id?.toString() === specialtyId?.toString(),
              )}
              id="specialty-typeahead"
              className="flex-grow-1"
              isValid={specialtyId}
            />
          </Form.Group>
          <Form.Label>ChatGPT Question</Form.Label>
          <TextEditor text={chatGPT_Ask} setText={setChatGPT_Ask} />

          {/* save section */}
          <Form.Group className="text-right my-3">
            <Button onClick={() => submitHandler()} variant="outline-success">
              <FaSave /> Update Changes
            </Button>
          </Form.Group>
        </Form>
      )}
      <Tabs>
        <Tab eventKey="members" title="Clinic Members">
          {members &&
            members.map((m, order = 1) => (
              <Member
                key={order}
                member={m}
                order={order + 1}
                clinicId={clinicId}
              />
            ))}
          {/* ADD NEW MEMBER */}
          <MemberForm clinicId={clinicId} />
          {/* save section */}
          <Form.Group className="text-right my-3">
            <Button onClick={() => submitHandler()} variant="outline-success">
              <FaSave /> Update Changes
            </Button>
          </Form.Group>
        </Tab>
        <Tab eventKey="secretarySection" title="Secretary Inputs">
          <h3>Clinic Services</h3>
          <ClinicServices
            clinicServices={clinicServices}
            setClinicServices={setClinicServices}
            clinicId={clinicId}
          />
          <MyLines type="dashed" />

          <h3>Default Patient Note</h3>
          <ClinicDefaultPatientNote
            defaultPatientNote={defaultPatientNote}
            setDefaultPatientNote={setDefaultPatientNote}
            clinicId={clinicId}
          />
          <MyLines type="dashed" />
        </Tab>
        <Tab eventKey="nurseSection" title="Nurse Inputs">
          <ClinicFollowups
            clinicFollowups={clinicFollowups}
            setClinicFollowups={setClinicFollowups}
            clinicId={clinicId}
          />
        </Tab>
        <Tab eventKey="physicianSection" title="Physician Inputs">
          {/* <pre>{JSON.stringify(clinicCheckLists, null, 2)}</pre> */}
          <ClinicPatientTags
            patientTags={patientTags}
            setPatientTags={setPatientTags}
            clinicId={clinicId}
          />
          <MyLines type="dashed" />

          <ClinicChecklists
            clinicCheckLists={clinicCheckLists}
            setClinicChecklists={setClinicChecklists}
            clinicId={clinicId}
          />
          <MyLines type="dashed" />

          <ClinicDefaultPhysicianNote
            defaultPhysicianNote={defaultPhysicianNote}
            setDefaultPhysicianNote={setDefaultPhysicianNote}
            clinicId={clinicId}
          />
        </Tab>
      </Tabs>
      <Help />
    </FormContainer>
  );
};

export default ClinicEditScreen;
